import Text from 'inquiry/components/Text';
import { PrivacyPolicyComponent, UiComponentType } from 'lib/interfaces/ui-components';
import { Inquiry } from 'verify/models/inquiry';

interface PrivacyPolicyProps {
  component: PrivacyPolicyComponent;
  inquiry: Inquiry;
}

/**
 * @deprecated
 * We are switching to rendering the PrivacyPolicy UI component as Text in
 * clients. Until all clients are able to support this, we explicitly render
 * a Text component on web as a tempfix.
 *
 * Once all clients support this, we can remove all PrivacyPolicy code in the
 * web client.
 */
const PrivacyPolicy = ({ component, inquiry }: PrivacyPolicyProps) => {
  return <Text component={{ ...component, type: UiComponentType.Text }} inquiry={inquiry} />;
};

export default PrivacyPolicy;
